import { Yup } from 'cng-web-lib'
import Namespace from '../../../../constants/locale/Namespace'
import * as ValidationRegex from 'src/common/NBCIValidationRegex.js'
import NBCICanadaInvoiceKeys from 'src/constants/locale/key/NBCICanadaInvoice'

function makeValidationSchema(translate) {
  const regexAlphaNumeric =
    ValidationRegex.regexAlphaNumeric
  let errMsgAlphaNumeric = translate(
    Namespace.N_B_C_I_CANADA_INVOICE,
    NBCICanadaInvoiceKeys.Validations.ERR_MSG_ALPHA_NUMERIC_SPEC_CHAR
  )
  // const errMsgAlphaNumeric =
  //   'Invalid Value - Allowed Alphanumeric, spaces, and /,+-$#@%&!^_:;.?()[]{}\'"'
  const regexDigitWithDecimal = ValidationRegex.regexDigitWithDecimal
  let errMsgDigitWithDecimal = translate(
    Namespace.N_B_C_I_CANADA_INVOICE,
    NBCICanadaInvoiceKeys.Validations.ERR_MSG_NUMERIC_DECIMAL
  )
  // const errMsgDigitWithDecimal =
  //   'Invalid Value - Allowed Digits with/without decimal'

  const validateStringField = (maxLength, regexPattern, errorMsg) =>
    Yup.string()
      .nullable()
      .matches(regexPattern, errorMsg)
      .max(
        maxLength,
        'Field can contain maximum of ' + maxLength + ' characters'
      )

  return Yup.object({
    typeNetContent: validateStringField(
      20,
      regexAlphaNumeric,
      errMsgAlphaNumeric
    ),
    quantity: validateStringField(
      20,
      regexDigitWithDecimal,
      errMsgDigitWithDecimal
    ),
    labelNo: validateStringField(15, regexAlphaNumeric, errMsgAlphaNumeric),
    importPurpose: validateStringField(
      15,
      regexAlphaNumeric,
      errMsgAlphaNumeric
    ),
    documentation: validateStringField(
      15,
      regexAlphaNumeric,
      errMsgAlphaNumeric
    ),
    registrationNo: validateStringField(
      15,
      regexAlphaNumeric,
      errMsgAlphaNumeric
    )
  })
}

export default makeValidationSchema
